import React from 'react';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import {
  CloudQueue, Flight, HomeIcon, NetworkCheck, PersonOutline, ShoppingCart,
} from '@tmap/mmm-style-guide/src/Icon';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';

export const itemMappings = [
  { type: 'population', icon: PersonOutline, label: 'Population' },
  { type: 'internetSpeed', icon: NetworkCheck, label: 'Internet Speed Rating' },
  { type: 'distanceToAirport', icon: Flight, label: 'Closest Airport' },
  { type: 'highTemp', icon: CloudQueue, label: 'Weather (High/Low)' },
  { type: 'medianHomeValue', icon: HomeIcon, label: 'Median Home Value (3BR, 2BA)' },
  { type: 'distanceToTarget', icon: ShoppingCart, label: 'Distance to Target Shopping Center' },
  { type: 'distanceToTractorSupply', icon: ShoppingCart, label: 'Distance to Tractor Supply' },
];

function PlaceInfoItem(props) {
  const {
    incentive,
    fact,
  } = props;

  let val = incentive[fact.type];
  if (!val) return null;
  switch (fact.type) {
    case 'population':
      val = new Intl.NumberFormat().format(val);
      break;
    case 'internetSpeed':
      val += ' Mbps';
      break;
    case 'distanceToAirport':
      val = (
        <>
          {incentive.nearestAirport ? (
            <>{incentive.nearestAirport}&nbsp;&bull;&nbsp;</>
          ) : (
            ''
          )}
          {val} mi
        </>
      );
      break;
    case 'highTemp':
      val = `${val} / ${incentive.lowTemp}`;
      break;
    case 'medianHomeValue':
      val = `$${new Intl.NumberFormat().format(val)}`;
      break;
    case 'distanceToTarget':
    case 'distanceToTractorSupply':
      val += 'mi';
      break;
    default:
      return null;
  }

  return (
    <Grid container spacing={4} sx={{ marginBottom: 1 }}>
      <Grid item><Typography variant='body2' color='textSecondary'><fact.icon /></Typography></Grid>
      <Grid item xs><Typography variant='body2'>{fact.label}</Typography></Grid>
      <Grid item xs sm={5} md={4} style={{ textAlign: 'right' }}><Typography variant='body1' />{val}</Grid>
    </Grid>
  );
}

export default PlaceInfoItem;
